// @ts-nocheck
import { Navigate } from "react-router-dom";

function Illustration() {
  return <Navigate to="/sign-in" replace />;
}

export default Illustration;
